import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, PlayCircle } from 'lucide-react';
export function FinalCTA() {
  return <section id="pricing" className="w-full bg-[#0F1B2D] text-[#FAFAF5] py-24 px-6 md:px-12 border-t border-gray-800" data-id="element-10">
      <div className="max-w-4xl mx-auto text-center" data-id="element-11">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-12">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-13">
            If you're done waiting to feel ready… <br data-id="element-14" />
            and you want a system that turns anxiety into a simple daily
            checklist…
          </h2>

          <div className="mt-12 mb-16" data-id="element-15">
            <div className="mb-6" data-id="element-16">
              <span className="text-gray-400 line-through text-xl mr-3" data-id="element-17">
                $19.99
              </span>
              <span className="text-[#E8722A] font-bold text-5xl md:text-6xl" data-id="element-18">
                $6.39
              </span>
              <span className="ml-3 inline-block bg-[#E8722A]/20 text-[#F59E0B] text-sm font-bold px-3 py-1 rounded-full" data-id="element-19">
                68% OFF
              </span>
            </div>
            <a href="https://ecoviewdigital.com/cart/51630819672351:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-[#E8722A] hover:bg-[#F59E0B] text-white font-bold text-2xl px-12 py-6 rounded-full transition-all shadow-[0_0_30px_rgba(232,114,42,0.4)] hover:shadow-[0_0_50px_rgba(232,114,42,0.6)] transform hover:-translate-y-1" data-id="element-20">
              Get the UGC Starter Kit Now <ArrowRight className="w-6 h-6" data-id="element-21" />
            </a>
            <p className="mt-4 text-sm text-gray-400" data-id="element-22">
              Instant digital download. Secure checkout.
            </p>
          </div>

          <div className="bg-[#162438] rounded-xl p-8 max-w-2xl mx-auto border border-gray-700" data-id="element-23">
            <h3 className="text-xl font-bold mb-6 text-white flex items-center justify-center gap-2" data-id="element-24">
              <PlayCircle className="w-6 h-6 text-[#E8722A]" data-id="element-25" />
              What happens right after you buy
            </h3>

            <div className="space-y-4 text-left" data-id="element-26">
              <p className="text-gray-300 text-center mb-6" data-id="element-27">
                You'll open the workbook and start Day 1:
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm md:text-base" data-id="element-28">
                <div className="bg-[#0F1B2D] p-4 rounded-lg text-center border border-gray-800" data-id="element-29">
                  <span className="block text-[#E8722A] font-bold mb-1" data-id="element-30">
                    15 Mins
                  </span>
                  Pick a niche
                </div>
                <div className="bg-[#0F1B2D] p-4 rounded-lg text-center border border-gray-800" data-id="element-31">
                  <span className="block text-[#E8722A] font-bold mb-1" data-id="element-32">
                    1 Hour
                  </span>
                  Map your 4 videos
                </div>
                <div className="bg-[#0F1B2D] p-4 rounded-lg text-center border border-gray-800" data-id="element-33">
                  <span className="block text-[#E8722A] font-bold mb-1" data-id="element-34">
                    24 Hours
                  </span>
                  Film first sample
                </div>
              </div>
            </div>

            <p className="mt-8 font-bold text-white text-lg" data-id="element-35">
              No hype. Just momentum.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}